import { useEventsUser } from 'hooks/user/useEvents'

import { Bottom } from './components/bottom'
import { Contact } from './components/contact'
import { Partner } from './components/partner'
import { Purchase } from './components/purchase'
import { Upcoming } from './components/upcoming'
import { Container, FooterContentWrapper, FooterWrapper, WhiteLine, WhiteLineContainer } from './footer.style'

export const Footer = () => {
    const { data } = useEventsUser()

    return (
        <Container>
            <FooterContentWrapper>
                <FooterWrapper>
                    <Purchase />
                    <Upcoming data={data} />
                    <Partner />
                    <Contact id="contact-section" />
                </FooterWrapper>
            </FooterContentWrapper>
            <WhiteLineContainer>
                <WhiteLine />
            </WhiteLineContainer>
            <FooterContentWrapper>
                <Bottom />
            </FooterContentWrapper>
        </Container>
    )
}
